/**
 * Privy reset signal.
 *
 * After `privy.logout()` resolves, the SDK can hold on to in-memory state from
 * the previous session (login flow step, pending OTP, error state). On the next
 * login attempt that stale state caused two reproducible bugs:
 *
 *   - phone OTP entry step skipped (Task 6)
 *   - email OTP step skipped after Phantom logout (Task 7)
 *
 * The most reliable cure that does not require editing the Privy modal is to
 * force a fresh PrivyProvider mount. Logout dispatches `mgt:privy-reset`; the
 * provider listens, bumps a `key` prop, and the SDK re-initialises with no
 * carried-over state.
 */

export const PRIVY_RESET_EVENT = "mgt:privy-reset" as const;

export function dispatchPrivyReset(): void {
	if (typeof window === "undefined") return;
	window.dispatchEvent(new CustomEvent(PRIVY_RESET_EVENT));
}

export function subscribePrivyReset(handler: () => void): () => void {
	if (typeof window === "undefined") return () => {};
	window.addEventListener(PRIVY_RESET_EVENT, handler);
	return () => window.removeEventListener(PRIVY_RESET_EVENT, handler);
}
